import { render, staticRenderFns } from "./scratch.vue?vue&type=template&id=0b32c18a&"
import script from "./scratch.vue?vue&type=script&lang=js&"
export * from "./scratch.vue?vue&type=script&lang=js&"
import style0 from "./scratch.vue?vue&type=style&index=0&id=0b32c18a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b32c18a')) {
      api.createRecord('0b32c18a', component.options)
    } else {
      api.reload('0b32c18a', component.options)
    }
    module.hot.accept("./scratch.vue?vue&type=template&id=0b32c18a&", function () {
      api.rerender('0b32c18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scratch/scratch.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/scratch/scratch.vue
// module id = aBzc
// module chunks = 0